import { HomePaths } from '@/services/dictionaries/Paths';

export const getPaymentsUrl = (isStandalone: boolean): string => {
    if (!isStandalone) {
        return HomePaths.Billing;
    }

    return `${location.origin}${HomePaths.BillingNew}`;
};
